import axios from '@axios'

export default {
  list: pagina => axios.get(`${process.env.VUE_APP_WCOND_API}/prestacaocontas/${pagina}`),
  getPdf: id => axios.get(`${process.env.VUE_APP_WCOND_API}/arquivo/blob/${id}`, { responseType: 'blob', timeout: 300000 }),
  demonstrativo: referencia => axios.get(`${process.env.VUE_APP_WCOND_API}/demonstrativo/sintetico/${referencia}`),
  getParecer: id => axios.get(`${process.env.VUE_APP_WCOND_API}/prestacaocontas/${id}/parecer`),
  aprovar: (id, ressalvas) => axios.post(`${process.env.VUE_APP_WCOND_API}/prestacaocontas/${id}/aprovar`, { ressalvas }),
  reprovar: (id, ressalvas) => axios.post(`${process.env.VUE_APP_WCOND_API}/prestacaocontas/${id}/reprovar`, { ressalvas }),
}
